import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import posed from 'react-pose';
import Icon, { IconSizes, IconVariants } from '../../components/foundations/Icon';
import * as css from './ExpandableGroup.css';

const ExpandableGroup = ({
    defaultExpanded = true,
    title = '',
    rightComponents = null,
    marked = false,
    hasWarning = false,
    headerAreaClassName = '',
    animatedAreaClassName = '',
    children,
}) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    const expandedHeightRef = useRef(null);

    const AnimatedRef = useRef(
        posed.div({
            expanded: {
                height: ({ element }) => {
                    if (!expandedHeightRef.current) {
                        let height = 0;
                        for (const child of element.children) {
                            height += child.getBoundingClientRect().height;
                        }
                        expandedHeightRef.current = height;
                    }
                    return expandedHeightRef.current;
                },
            },
            collapsed: {
                height: '0px',
            },
        })
    );

    const Animated = AnimatedRef.current;
    return (
        <div
            className={classNames(css.container, {
                [css.expanded]: expanded,
                [css.marked]: marked,
                [css.markedWarning]: hasWarning,
            })}
        >
            <div className={classNames(css.headerArea, headerAreaClassName)} onClick={() => setExpanded(prev => !prev)}>
                <Icon name={expanded ? 'minus' : 'plus'} size={IconSizes.SMALL} variant={IconVariants.LIGHT} />
                <div>{title}</div>
                <div className={css.titleRightArea}>{rightComponents}</div>
            </div>
            <Animated
                className={classNames(css.animatedArea, animatedAreaClassName)}
                pose={expanded ? 'expanded' : 'collapsed'}
            >
                <div className={css.contentContainer}>{children}</div>
            </Animated>
        </div>
    );
};

ExpandableGroup.propTypes = {
    defaultExpanded: PropTypes.bool,
    rightComponents: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element, PropTypes.string]),
    title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    marked: PropTypes.bool,
    hasWarning: PropTypes.bool,
    headerAreaClassName: PropTypes.string,
    animatedAreaClassName: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default ExpandableGroup;
